module.exports = __webpack_public_path__ + "assets/img/manufacturing.2422ce44.png";